import script from "./TempH.vue?vue&type=script&lang=ts&setup=true"
export * from "./TempH.vue?vue&type=script&lang=ts&setup=true"

import "./TempH.vue?vue&type=style&index=0&id=95fd8640&lang=scss&scoped=true"

import exportComponent from "/apps/jenkins/workspace/client-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-95fd8640"]])

export default __exports__